import * as ShieldModule from 'shield-js-npm'
import type { Shield as ShieldType, ShieldProps } from 'shield-js-npm'

interface DeviceIntelligenceResponse {
  result: {
    session_id: string
  }
}

export const getShieldSessionId = async () => {
  const ShieldCtor: new () => ShieldType =
    (ShieldModule as any).Shield ?? (ShieldModule as any).default?.Shield ?? (ShieldModule as any)
  if (typeof ShieldCtor !== 'function') {
    console.error('Shield constructor not found in shield-js-npm module export')
    return null
  }
  const shield: ShieldType = new ShieldCtor()
  const config = useRuntimeConfig()
  const props: ShieldProps = {
    siteId: config.public.SHIELD_SITE_ID as string
  }

  try {
    await shield.init(props)
    const res = (await shield.getDeviceIntelligence()) as DeviceIntelligenceResponse

    return res.result.session_id
  } catch (error) {
    console.error('Error getting shield session id: ', error)
    return null
  }
}
